import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar'
import { InfoMessageSnackBarData } from '@wm-front/shared/interfaces'

@Component({
  selector: 'wm-front-info-message',
  templateUrl: './info-message.component.html',
  styleUrls: ['./info-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule],
})
export class InfoMessageComponent {
  public data = inject<InfoMessageSnackBarData>(MAT_SNACK_BAR_DATA)
}
